import React, { Component, createRef } from "react";
import { withTranslation } from "react-i18next";
import { verifyUsername } from "../api/api";
import ForgotAccountCommon from "./ForgotAccountCommon";
import TextInput from "./common/TextInput";
import ErrorAlert from "./common/ErrorAlert";
import * as CONSTANTS from "../constants";
import ReCAPTCHA from "react-google-recaptcha"

const initialState = {
  username: "",
  userType: "",
  productType: "",
  transactionId: "",
  sendBy: [],
  errors: { username: "", recaptcha: ""  },
  genericError: null,
  loading: false,
};

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;
  }

  handaleSubmit = async (e) => {
    // e.preventDefault();
    // console.log(e.target);
    const formData = new FormData(e.target);
    // console.log(formData.entries());

    let formIsValid = false;
    formIsValid = this.handleValidation(formData.entries());

    // console.log("ForgotPassword :: handaleSubmit :: formIsValid => " + formIsValid);

    e.preventDefault();
    if (formIsValid) {
      await this.userInfo();
    }
  };

  userInfo = async () => {
    // API CALL - VALIDATE USERNAME
    let requestBody = {
      username: this.state.username,
      clientInfo: {
        clientId: this.props.clientId,
        ...(this.props.clientId !== "EPORTAL" && {
          redirectUrl: this.props.redirectURL,
        }),
      },
    };

    this.setState({
      loading: true,
    });

    try {
      let result = await verifyUsername(requestBody);
      let genericError = "";
      console.log(
        "ForgotPassword :: User Info :: result => " + JSON.stringify(result)
      );
      // console.log("result.transactionId : " + result.transactionId);
      // console.log("result.userInfo.sms : " + result.userInfo.sms);
      // console.log("result.userInfo.email : " + result.userInfo.email);
   

      if(CONSTANTS.USER_TYPE_INDIVIDUAL ===result.userInfo.userType || CONSTANTS.USER_TYPE_NON_MOBILY ===result.userInfo.userType){
              console.log("Individual account selected");
              const redirectUrl =window.MOBILE_APP_URL;
              console.log("CONSUMER userType URL::"+redirectUrl);
              window.location.replace(redirectUrl);
      }else{
          let sendByArray = [];
          if (result.userInfo.sms) {
            sendByArray.push("SMS");
          }
          if (result.userInfo.email) {
            sendByArray.push("Email");
          }
            // For 3rd party clients, prevent user from proceeding according to the following rules:
          if (this.props.isThirdParty) {
            if (
              result.userInfo.userType === CONSTANTS.USER_TYPE_INDIVIDUAL && this.props.clientInfo[CONSTANTS.USER_TYPE_INDIVIDUAL] != 'Y'
              && (result.userInfo.productType === CONSTANTS.PRODUCT_TYPE_GSM && this.props.clientInfo[CONSTANTS.PRODUCT_TYPE_GSM] != 'Y' ||
                result.userInfo.productType === CONSTANTS.PRODUCT_TYPE_FTTH && this.props.clientInfo[CONSTANTS.PRODUCT_TYPE_FTTH] != 'Y' ||
                result.userInfo.productType === CONSTANTS.PRODUCT_TYPE_CONNECT && this.props.clientInfo[CONSTANTS.PRODUCT_TYPE_CONNECT] != 'Y')
              ||
              result.userInfo.userType === CONSTANTS.USER_TYPE_CORPORATE && this.props.clientInfo[CONSTANTS.USER_TYPE_CORPORATE] != 'Y'
              ||
              result.userInfo.userType === CONSTANTS.USER_TYPE_NON_MOBILY && this.props.clientInfo[CONSTANTS.USER_TYPE_NON_MOBILY] != 'Y'
            ) {
              genericError = "third_party_error";
            }
          }

          this.setState({
            userType: result.userInfo.userType,
            productType: result.userInfo.productType,
            sendBy: sendByArray,
            transactionId: result.transactionId,
            genericError: genericError,
            loading: false,
          });
          console.log("============> usertype : " + this.state.userType);
          console.log("============> productType : " + this.state.productType);
      

      }

    
 } catch (error) {
      console.log("ForgotPassword :: userInfo :: Error => " + error);
      this.setState({
        genericError: error,
        loading: false,
        //just to test i have to remove it
      });
    }


  };

  //bind username value
  handleUserChange = (evt) => {
    // console.log(" ######### handleUserChange : " + evt.target.value);
    this.setState({
      username: evt.target.value,
    });
  };

  resetForm = () => {
    this.setState(initialState);
  };
  recaptchaRef = createRef();
  render() {
    const { t } = this.props;
    const { loading } = this.state;

    return (
      <div>
        {this.state.genericError && <ErrorAlert error={this.state.genericError} />}
        {!this.state.userType ? (
          <form id="forgot-password-form" onSubmit={this.handaleSubmit}>
            {" "}
            {/* red alert  */}
            {/* {this.state.errors.username ? (
              <div className="alert alert-danger" role="alert">
                {t(this.state.errors.username)}{" "}
                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
              </div>
            ) : (
              <div className="empty-alert">&nbsp;</div>
            )} */}
            {/* red alert  */}
            <div
              className={
                "form-group " + (this.state.errors.username ? "not-valid" : "")
              }
            >
              {/* <label
                className="input-label"
                style={{
                  visibility: this.state.username ? "visible" : "hidden",
                }}
              >
                {t("username")}
              </label> */}

              {/* <input
                type="text"
                className="form-control"
                placeholder={t("username")}
                value={this.state.username}
                maxLength="50"
                onChange={this.handleUserChange}
              /> */}

              {/* USERNAME FIELD */}
              <TextInput
                label={"username"}
                name={"username"}
                value={this.state.username}
                type={"text"}
                error={this.state.errors.username}
                handleChange={this.handleUserChange}
                // handleBlur={this.verifyUsername}
                render={true}
              />
                {/* ReCAPTCHA PART */}
                <ReCAPTCHA
                  ref={this.recaptchaRef}
                  className="mt-4"
                  sitekey={window.CAPTCHA_V2_SITE_KEY}
                  type="image"
                  hl={window.lang === "ar" ? "ar" : "en"}
                  name={"recaptcha"}
                />
                {this.state.errors.recaptcha && (
                  <ErrorAlert error={this.state.errors.recaptcha} />
                )}

              <button
                id="forgot-password-submit-btn"
                type="submit"
                className="mt-4 btn min_outlin_btn active"
              >
                {t("submit_btn")}{" "}
                <i className="fa fa-arrow-right" aria-hidden="true"></i>
              </button>
            </div>
          </form>
        ) : (
            <ForgotAccountCommon
              formType={CONSTANTS.FORM_TYPE_FORGOT_PASSWORD}
              userType={this.state.userType}
              productType={this.state.productType}
              username={this.state.username}
              sendBy={this.state.sendBy}
              setShowSuccessMsg={this.props.setShowSuccessMsg}
              setMessageDetails={this.props.setMessageDetails}
              transactionId={this.state.transactionId}
              resetForm={this.resetForm}
              clientId={this.props.clientId}
              redirectURL={this.props.redirectURL}
              clientInfo={this.props.clientInfo}
              isThirdParty={this.props.isThirdParty}
              isConsumer={this.props.isConsumer}
            />
          )}
        {loading ? <div className="loading">Loading&#8230;</div> : null}
      </div>
    );
  }

  handleValidation(formData) {
    // console.log("ForgotPassword :: handleValidation :: Enter");

    let errors = {};
    let formIsValid = false;

    // make all form field required
    for (var [key, value] of formData) {
      if (key !== "g-recaptcha-response") {
        if (value === null || value === "") {
          errors[key] = "required";
        }
      }

      if (key === "g-recaptcha-response") {
        if (!value) {
          //formIsValid = false;
          errors["recaptcha"] = "required";
        }
      }
      if (value === null || value === "") {
        errors[key] = "required";
      }


    }

    if (JSON.stringify(errors) === "{}") {
      // console.log(" ===> JSON.stringify(errors) " + JSON.stringify(errors));
      formIsValid = true;
    }

    this.setState({ errors: errors, genericError: null });
    return formIsValid;
  }
}

export default withTranslation()(ForgotPassword);
